module.exports = __webpack_public_path__ + "static/media/presentasjon.e9a92a29.jpg";